import * as actions from "./actionTypes";

/*
 * For app state *
 */
export const setCurrentPage = (currentPage) => ({
  type: actions.SET_CURRENT_PAGE,
  currentPage,
});

/*export const setAnalyze = (analyzeSelected) => ({
  type: actions.SET_ANALYZE,
  analyzeSelected,
});*/

export const setSelectedAttribute = (selectedAttribute) => ({
  type: actions.SELECT_ATTRIBUTE,
  selectedAttribute,
});

/*
 * For data state *
 */
/*export const fetchData = () => ({
  type: actions.FETCH_DATA,
});*/

export const fetchGeoDistricts = (data) => ({
  type: actions.FETCH_GEO_DISTRICTS,
  geoDistricts: data,
});

export const fetchDataHKDistricts = (data) => ({
  type: actions.FETCH_DATA_DISTRICTS,
  data,
});

export const fetchDataHKStores = (data) => ({
  type: actions.FETCH_DATA_STORES,
  data,
});

/*export const fetchDataHKConsumerViewer = (data) => ({
  type: actions.FETCH_DATA_CONSUMER_VIEWER,
  consumerViewer: data,
});*/

export const fetchDataHKCountry = (data) => ({
  type: actions.FETCH_DATA_COUNTRY,
  country: data,
});

/*
 * For Reports
 */

export const fetchDailyPatterns = (data) => ({
  type: actions.FETCH_DAILY_PATTERNS,
  patterns: data,
});

export const fetchRecentTrends = (data) => ({
  type: actions.FETCH_RECENT_TRENDS,
  payload: data,
});

export const selectReportType = (type) => ({
  type: actions.SELECT_REPORT_TYPE,
  payload: type,
});

export const clickStore = (id) => ({
  type: actions.CLICK_STORE,
  payload: id,
});

export const selectStore = (id) => ({
  type: actions.SELECT_STORE,
  payload: id,
});

export const clickAttribute = (attribute) => ({
  type: actions.CLICK_ATTRIBUTE,
  payload: attribute,
});

export const selectAttribute = (attribute) => ({
  type: actions.SELECT_ATTRIBUTE,
  payload: attribute,
});

export const selectAnalyzeType = (type) => ({
  type: actions.SELECT_ANALYZE_TYPE,
  payload: type,
});
